import React from "react";

import { useParams } from "react-router-dom";
import { REPORTS_IDS } from "consts/reports";
import { CoursesFinancialReport } from "./reports/CoursesFinancialReport";
import { CourseGroupsFinancialReport } from "./reports/CourseGroupsFinancialReport";
import { SurveysCourses } from "./reports/SurveysCourses";
import { SurveysCourse } from "./reports/SurveysCourse";
import { CourseRegistrationByCourseReport } from "./reports/CourseRegistrationByCourseReport";
import { UserRegistrationsReport } from "./reports/UserRegistrationsReport";
import { PlaceCoursesReport } from "./reports/PlaceCoursesReport";

export const ReportPage = (): JSX.Element | null => {
  const { reportId } = useParams();

  if (reportId === REPORTS_IDS.COURSES_FINANCIAL_REPORT.toString()) return <CoursesFinancialReport />;
  if (reportId === REPORTS_IDS.COURSES_GROUP_FINANCIAL_REPORT.toString()) return <CourseGroupsFinancialReport />;
  if (reportId === REPORTS_IDS.SURVEYS_COURSES.toString()) return <SurveysCourses />;
  if (reportId === REPORTS_IDS.SURVEYS_COURSE.toString()) return <SurveysCourse />;
  if (reportId === REPORTS_IDS.COURSE_REGISTRATIONS_BY_COURSE.toString()) return <CourseRegistrationByCourseReport />;
  if (reportId === REPORTS_IDS.USER_REGISTRATIONS.toString()) return <UserRegistrationsReport />;
  if (reportId === REPORTS_IDS.PLACE_COURSES.toString()) return <PlaceCoursesReport />;

  return null;
};
